import HealthPanel from './HealthPanel';
import './HealthPanel.scss';
import healthPanelSchema from './healthPanelSchema';

export { HealthPanel, healthPanelSchema };
